import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-87">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-88">
          {label}
        </label>}
      <input id={inputId} className={`
          block w-full rounded-md border-gray-300 shadow-sm 
          focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
          disabled:bg-gray-50 disabled:text-gray-500
          ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300'}
          ${className}
        `} {...props} data-id="element-89" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-90">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-91">{helperText}</p>}
    </div>;
}